import Carousel from 'bootstrap/js/dist/carousel';

const bannerCarousel = document.querySelector('#bannerCarousel');

if (bannerCarousel) {
    new Carousel(bannerCarousel, {
        interval: 3000,
        touch: true,
    });
}
